'use client';

import { useState } from 'react';
import { Sheet } from 'react-modal-sheet';

interface BottomSheetProps<T = boolean | string> {
  isOpen: boolean;
  close: (param: T) => void;
  children: React.ReactNode;
  title: string;
}

export default function BottomSheet<T = boolean | string>({
  isOpen,
  close,
  children,
  title,
}: BottomSheetProps<T>) {
  const [isReady, setIsReady] = useState(false);

  return (
    <Sheet
      className="bottom_sheet"
      isOpen={isOpen}
      onClose={() => close(false as T)}
      detent="content-height"
      onOpenStart={() => setIsReady(true)}
      onCloseStart={() => setIsReady(false)}
    >
      <Sheet.Container className="bottom_sheet_body">
        <div className="headline">
          <p className="title">{title}</p>
          <button
            onClick={() => close(false as T)}
            className="btn_close"
            aria-label="닫기"
          ></button>
        </div>
        <Sheet.Content
          style={{
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {children}
        </Sheet.Content>
      </Sheet.Container>
      {isReady ? <Sheet.Backdrop onTap={() => close(false as T)} /> : <></>}
    </Sheet>
  );
}
